import { Button, Flex, Input, Modal } from 'antd';
import React, { FC, useState } from 'react';

interface IProps {
  isModalOpen: boolean;
  title: string;
  handleCancel: () => void;
  handleOk: () => void;
  setComment: (value: string) => void;
  loading?: boolean;
  okLabel?: string;
  placeholder?: string;
}

const SingleReviewModal: FC<IProps> = props => {
  const {
    isModalOpen,
    handleCancel,
    handleOk,
    setComment,
    title,
    loading,
    okLabel = 'Accept All',
    placeholder = 'Add a comment for all accepted segmentations (optional)...',
  } = props;
  const [_, setText] = useState('');

  const onChange = (value: string) => {
    setText(value);
    setComment(value);
  };

  return (
    <Modal
      title={title}
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={
        <Flex justify="space-around" gap={12} style={{ marginTop: 24 }}>
          <Button onClick={handleCancel} disabled={loading}>
            Cancel
          </Button>
          <Button type={'primary'} onClick={handleOk} loading={loading} disabled={loading}>
            {loading ? 'Submitting...' : okLabel}
          </Button>
        </Flex>
      }
    >
      <Input.TextArea
        showCount
        rows={5}
        onChange={e => onChange(e.target.value)}
        maxLength={255}
        placeholder={placeholder}
        style={{ height: '100%', resize: 'none' }}
      />
    </Modal>
  );
};

export default SingleReviewModal;
